import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog ,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { isUndefined } from "util";
import 'rxjs/add/operator/filter';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/debounceTime';
import { Router } from '@angular/router';
import { NativeWindoRefService } from '../shared/services/native-windo-ref.service';
import { BroadcastEventService } from "../shared/services/broadcast.event.service";
import { Anomalies } from "../classes/anomaly";
import * as L from 'leaflet';
import { CopySurveyDialogComponent, DeleteSurveyDialogComponent, EditSurveyInfoComponent } from 'app/questionnaires/questionnaires.component';
import { ShareSurveyservice } from 'app/questionnaires/share-superadmin-dialog';
import { shareSurvey } from 'app/questionnaires/share-admin-dialog';
import { superAdminService } from 'app/shared/services/superAdminService';
import { Templateservice } from 'app/questionnaires/new-template';
import { ToastOptions, ToastyService } from 'ng2-toasty';
import { AddTeamDialogComponent } from 'app/surveyers/surveyers.component';
import { AssignTeamComponent } from 'app/centralPanel/central-panel.component';
import { RangeForRepeaterDialogComponent } from 'app/range-for-repeater-dialog/range-for-repeater-dialog.component';
declare var amplitude:any;

@Component({
  selector: '',
  templateUrl: './overview-dialog.component.html',
  styleUrls: ['./overview-dialog.component.css']
})
export class OverviewDialogComponent implements OnInit {

  langObj = { 'en' : 'English' , 'hi' : 'Hindi' , 'fr' : 'French','es' : 'Spanish'};
  questionnaireData:any;
  title:any;
  newloc:boolean;
  nativeWindow:any;
  pLanguage:any;
  sLanguage:any;
  status:any;
  anomalies : Anomalies[];
  showAnomalyRepeater : boolean = false;
  repeaterAnomalyMsg : string = "";
  repeaterAnomalyHeading :string =  "";
  repeaterAnomalyMsg_S : string = "";
  questions:any;
  showAnomaly:boolean = false;
  simpleAnomalyHeading : string = "";
  simpleAnomalyMsg : string = "";
  simpleAnomalyMsg_S :string = '';
  locations : any[];
  map :any;
  longitudes:any[];
  latitudes:any;
  mapbutton:boolean = false;
  preview:boolean = false;
  block:any;
  questionsTemplateView :boolean = true ;
  markerClusterData: any[] = [];
  mapLocations = [];
  usernames:string = "";
  teamNames: string = "";
  optionsSpec: {
    layers: any[],
    zoom: number,
    center: number[],
  } = {
      layers: [
        {
          url: 'http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
          maxZoom: 25,
          attribution: 'Map'
        }
      ],
      zoom: 5,
      center: [20.5937, 78.9629]
  };

  center =  [20.5937, 78.9629];
  zoom = 5;
  options = {
    layers: this.optionsSpec.layers.map((l) => {
      return L.tileLayer(l.url, { maxZoom: l.maxZoom, attribution: l.attribution });
    }),
    zoom: this.optionsSpec.zoom,
    center: L.latLng(this.optionsSpec.center[0], this.optionsSpec.center[1])
  };
  markerClusterGroup: L.MarkerClusterGroup;
  qID : string;
  hasSubForm = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private broadcastEventService: BroadcastEventService,private cdr:ChangeDetectorRef, 
  private nativeWindoRefService: NativeWindoRefService,public router: Router,
  public dialog: MatDialog,public SurveyTypeDialogRef: MatDialogRef<OverviewDialogComponent>,
  private restApiService:RestApiService, private superAdminService: superAdminService,
  private toastyService: ToastyService) {

    this.title = this.data.surveyName;
    this.qID = this.data.qID;
    this.nativeWindow = nativeWindoRefService.getNativeWindow();
    if(this.data.parent_group == null || isUndefined(this.data.parent_group)){
      this.mapbutton = true;
    }
    this.questionnaireData =  this.data;
    this.hasSubForm = this.data.hasSubForm;
    this.questionnaireData['primary_language'] = this.langObj[this.data['primary_lang']];
    if(this.data['second_lang'])
    {
      this.questionnaireData['second_language'] = this.langObj[this.data['second_lang']];
    }
    if(this.data['status'])
    {
      if (this.data['status'] == 'p') {
        this.data['status_value'] =  'Published';
      }
      else {
        this.data['status_value'] =  'Draft';
      }
    }
    this.questions = this.data.question;
    if(this.questions.length > 0)
    {
      this.preview = true;
    }
    if(this.questionnaireData.users){
      for(let i = 0; i <this.questionnaireData.users.length; i++){
        if(i == this.questionnaireData.users.length-1)
        {
          this.usernames = this.usernames + this.questionnaireData.users[i].userName;
        }
        else
        {
        this.usernames = this.usernames + this.questionnaireData.users[i].userName + ','
        }
      }
    }
    else
    {
      this.usernames = "None";
    }

    if(this.questionnaireData.teams_name){
      for(let i = 0; i <this.questionnaireData.teams_name.length; i++){
        if(this.questionnaireData.teams_name[i] != null){
          if(i == this.questionnaireData.teams_name.length-1)
          {
            this.teamNames = this.teamNames + this.questionnaireData.teams_name[i];
          }
          else
          {
            this.teamNames = this.teamNames + this.questionnaireData.teams_name[i] + ','
          }
        }
      }
    }
    if(this.teamNames=="" || this.teamNames == null){
      this.teamNames  = "--";
    }
  }
  ngOnInit() {
  }

  repeaterDialog(qID,action,qName){
    let newSurveyDialogRef;
    if(action == 'enable'){
      newSurveyDialogRef = this.dialog.open(RangeForRepeaterDialogComponent, {
        width: '1120px',
        height:'560px',
        data: {qID: qID , action : action, qName:qName}
      });
    }
    else{
      newSurveyDialogRef = this.dialog.open(RangeForRepeaterDialogComponent, {
        height: '305px',
        width: '400px',
        data: {qID: qID , action : action, qName:qName}
      });
    }
    newSurveyDialogRef.afterClosed().subscribe(result => {
      if(result && result.success != false){
        if(action == 'enable'){
          // assigning dummy values to making it repeater...
          this.questionnaireData.max_repeat = 1;
          this.questionnaireData.min_repeat = 1;
        }
        else{
          // assigning dummy values to removing it repeater...
          this.questionnaireData.max_repeat = 0;
          this.questionnaireData.min_repeat = 0;
        }
      }
    });
  }

  checkIfrepeater(form){
    if(parseInt(form.max_repeat) > 0 && parseInt(form.min_repeat) > 0)
    {
      return true
    }
    return false;
  }

  LocationView(showLocation:boolean){
    if(this.questionsTemplateView)
    {
      if(!showLocation){
        return;
      }
      this.questionsTemplateView = false;

      if(this.markerClusterData.length == 0)
      {
        this.restApiService.definedAreasForSurvey(this.data.qID).subscribe(res=>{
          if(res.success)
          {
            this.markerClusterData = [];
            // let mapLocation = [{ teamName : "team1" , latitude :" 20.5937",longitude:" 78.9629" ,radius : 10 ,name: "dfgh"},
            // { teamName : "team2", latitude : "20",longitude: "78" ,radius : 20000 ,name: "dfgh"},
            // { teamName : "team3" ,latitude : "19.5937",longitude:  "77.9629" ,radius : 30 ,name: "dfgh"}]
            let mapLocation = res.result;
            this.mapLocations = mapLocation;
            let meters_per_pixel = 156543.03392 * Math.cos(25 * Math.PI / 180) / Math.pow(2, this.zoom);
            for (let i in mapLocation) {
              this.markerClusterData.push(L.circleMarker([parseFloat(mapLocation[i].latitude),parseFloat(mapLocation[i]['longitude'])],{'id': mapLocation[i].teamName , 'radius' : (parseInt(mapLocation[i].radius))/meters_per_pixel }).on('click', this.onclick.bind(this)).bindPopup(mapLocation[i].name + "  -  " + mapLocation[i].teamName).openPopup());
            }
          }
          else
          {
            console.log("error")
          }
        })

      }
    }
    else{
      if(showLocation){
        return;
      }
      this.questionsTemplateView = true;
      this.preview = false;
      if(this.questions.length > 0)
      {
        this.preview = true;
      }
    }
  }

  markerClusterReady(group: L.MarkerClusterGroup) {
    this.markerClusterGroup = group;
    this.markerClusterGroup.options.iconCreateFunction = function (cluster) {
      return L.divIcon({ html: '<b style="padding:1.5rem; background-color: #2D9CDB; text-align: center;font-size: 16px; border-radius:50%; color:#FFFFFF">' + cluster.getChildCount() + '</b>', className: 'my-div-icon', iconSize: L.point(40, 40) });
    }
    this.markerClusterGroup.options.maxClusterRadius = 10;
    this.markerClusterGroup.options.singleMarkerMode = true;
  }

  onMapReady(map){
    map.on('zoomend', () => {
      let meters_per_pixel = 156543.03392 * Math.cos(25 * Math.PI / 180) / Math.pow(2, map.getZoom());
      let mapLocation = this.mapLocations;
      this.markerClusterData = [];
      for (let i in mapLocation) {
        this.markerClusterData.push(L.circleMarker([parseFloat(mapLocation[i].latitude),parseFloat(mapLocation[i]['longitude'])],{'id': mapLocation[i].teamName , 'radius' : (parseInt(mapLocation[i].radius))/meters_per_pixel }).on('click', this.onclick.bind(this)).bindPopup(mapLocation[i].name + "  -  " + mapLocation[i].teamName).openPopup());
      }
      this.cdr.detectChanges();
  });
  }

  onclick(e){
    // console.log(e);
  }

  formView(){
    this.questionsTemplateView =  true;
  }

  onDiscard()
  {
    this.SurveyTypeDialogRef.close({success:false});
  }
  getQuestionnaireURL() {
    amplitude.getInstance().logEvent('EditFormbuttonclicked');
    var currentAbsoluteUrl = this.nativeWindow.location.href;
    var currentRelativeUrl = this.router.url;
    var index = currentAbsoluteUrl.indexOf(currentRelativeUrl);
    var baseUrl = currentAbsoluteUrl.substring(0, index);
    window.open(baseUrl + '/create-questionnaire/' + this.data.qID);
  }

  isQuestionDep(question): boolean {
    if (question.Qn_Deps.length > 0) {
      return true;
    }
    return false;
  }

  getParticularVersionQuestions(index) {
    if (index < this.questionnaireData.quesVersions.length) {
      this.questions = this.questionnaireData.quesVersions[index];
    }
  }
  getLatestQuestions(){
    this.questions = this.questionnaireData.question;
  }

  editSurvey(){
    console.log("editsurvey",this.data);
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Editinfo"});

    let dialogRef = this.dialog.open(EditSurveyInfoComponent, {
      height: '560px',
      width: '1120px',
      data:this.data
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.success){
        this.SurveyTypeDialogRef.close({success:true});
      }
    });
  }


  createCopy(){
    const qnr= this.data;
    const type = this.data.child_group == null?0:1;
    const form_type = 'Master';
    //copyQnr=qnr;
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Createcopy"});
    let dialogRef = this.dialog.open(CopySurveyDialogComponent, {
      width: '1120px',
      height: '560px',
      data:{qnr:qnr,qnr_type:type,form_type:form_type,surveyName:this.questionnaireData.surveyName}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result && result.success){
        this.SurveyTypeDialogRef.close({success:true});
      }
    });
  }

  deleteqnr(){
    const qnr = this.data.qID;
    const qnrName = this.data.qnrName;
    const type = this.data.child_group==null?0:1;
    
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Delete Survey"});

    let typeDefined = type;
    // if(typeDefined == 2)
    // {
    //   type = 1;
    // }
    // else{
    //   type = 0;
    // }
    let dialogRef = this.dialog.open(DeleteSurveyDialogComponent, {
      height: '290px',
      width: '400px',
      data: { type: type, qID: qnr, surveyName: qnrName }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.SurveyTypeDialogRef.close({success:true});
      }
    });
  }
  download()
  {
    const qID = this.data.qID;
    const qnrName = this.data.qnrName;
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Download"});
    this.restApiService.getQnrExcel(qID,qnrName).subscribe(
      result => {
        // console.log(result);
        if(!(result == 'false'))
        {
          var a = document.createElement('a');
          a.href = result;
          a.target = '_blank';
          a.download = 'data.xlsx';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
        else{
          console.log("NO DATA");
        } 
    });
  }

  sharesurvey(){
    const qnr = this.data;
    amplitude.getInstance().logEvent('carddropdownclicked', { "options": "Share"});

   if(this.superAdminService.getData())
   {
    let dialogRef = this.dialog.open(ShareSurveyservice, {
      width: '1120px',
      height: '560px',
      data:qnr
    });
    dialogRef.afterClosed().subscribe(() => {

    });
  }
  else{
    let dialogRef = this.dialog.open(shareSurvey, {
      width: '1120px',
      height: '560px',
      data:qnr
    });
    dialogRef.afterClosed().subscribe(() => {
      
    });
  }
  }

  createTemplate(){
    const data= this.data;
    if (data.question.length > 0) {
      let dialogRef = this.dialog.open(Templateservice, {
        panelClass:'custom-dialog-class',
        width: '1120px',
        height: '560px',
        data:data
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result!=undefined)
        {
        if (result.success != false) {
          var toastOptions: ToastOptions = {title: "Template Created", msg: "New template was successfully created.", showClose: true, timeout: 3000, theme: 'bootstrap'};
          this.toastyService.success(toastOptions);
          // this.getUserTemplates();
        }
        else {
          var toastOptions: ToastOptions = {title: "Could not Publish", msg: result.msg, showClose: true, timeout: 3000, theme: 'bootstrap'};
          this.toastyService.error(toastOptions);
        }
      }
      });
    }
    else {
      // console.log('no question present');
      var toastOptions: ToastOptions = {
        title: "Could not Publish",
        msg:"No questions present in the survey - "+ data.surveyName ,
        showClose: true,
        timeout: 3000,
        theme: 'bootstrap'
      };
      this.toastyService.error(toastOptions);
    }
  }

  viewPerformance(){
    const qnr= this.data;
    console.log("..closing ref");
    this.SurveyTypeDialogRef.close({success:false});
    localStorage.setItem("selectedSIdForPerformance",qnr.qID);
    localStorage.setItem("selectedAdminIdForPerformance",qnr.adminID);
    localStorage.setItem("selectedSurveyName",qnr.surveyName);
    this.router.navigate(["./view-performance"]);
  }

  viewResponses(){
    const qnr= this.data;
    console.log("..closing ref");
    this.SurveyTypeDialogRef.close({success:false});
    this.router.navigate(['./survey-data'],{
      queryParams:{
        'qnr':JSON.stringify(qnr)
      },
      queryParamsHandling: 'merge'
    })
  }

  assignTeam(){
    let data = {
      surveyId:this.data.qID,
      surveyName:this.data.surveyName,
      fromSurvey:true
    }
    let dialogRef = this.dialog.open(AssignTeamComponent, {
      width: '68%',
      height: '600px',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/newSurveyDialog/overview-dialog.component.ts